export enum FakturaStatus {
    Afventer = 0,
    Godkendt = 1, // Fakturaen skal betales
    Afvist = 2, // Fakturaen skal ikke betales
    Afslaaet = 3 // Jeg skal ikke godkende denne faktura
}
